<template>
  <router-link class="tile" :to="toLink">
    <lazy-image class="tile-background" :item="imageItem" sizes="30w" rootMargin="0px" />
  </router-link>
</template>
<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import LazyImage from '../utils/LazyImage'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'

export default {
  props: ['item'],
  name: 'related-colors-item',
  components: {
    LazyImage
  },
  computed: {
    localizedUrl() {
      return currentStoreView().url || '';
    },
    toLink(){
      return `${this.localizedUrl}/product/${this.item.id}`;
    },
    imageItem() {
      return {
        url: this.item.soldat.src,
        lowDefinitionUrl: ImageManager.getLowDefinition(this.item.soldat.src, 200, 1),
        srcset: ImageManager.getSrcSet(this.item.soldat.src, 1000, 100, 100, 1),
        alt: this.item.soldat.alt,
        width: 86,
        height: 110
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .tile {
    width: fit-content;
    display: block;
    
    &-background {
      background-color: var(--zenith-component-product-header-background);
      display: flex;
      justify-content: center;
      justify-items: center;
      width: fit-content;
    }
  }
</style>